<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo"
    >
      <!--<el-menu-item index="1" @click="toNewRouter('finance-over-view')" v-if="permissionCodes.indexOf('013001000') !== -1">-->
      <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
      <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item
        index="7"
        @click="toNewRouter('investment-manage')"
        v-if="permissionCodes.indexOf('017003000') !== -1"
      >
        <i class="el-icon-damai-Group" style="font-size: 16px"></i>
        <span slot="title">招商部管理</span>
      </el-menu-item>
      <el-menu-item
        index="2"
        @click="toNewRouter('agent-manage')"
        v-if="permissionCodes.indexOf('017002000') !== -1"
      >
        <i class="el-icon-damai-jingliren_o" style="font-size: 26px"></i>
        <span slot="title">经纪人管理</span>
      </el-menu-item>
      <el-menu-item index="1" @click="toNewRouter('custom-management')" v-if="permissionCodes.indexOf('017006000') !== -1">
        <i class="el-icon-damai-kehuguanli"></i>
        <span slot="title">客户管理</span>
      </el-menu-item>
      <el-menu-item
        index="3"
        @click="toNewRouter('agent-house')"
        v-if="permissionCodes.indexOf('017001000') !== -1"
      >
        <i class="el-icon-damai-qiye2"></i>
        <span slot="title">房源管理</span>
      </el-menu-item>

      <el-menu-item
        index="9"
        @click="toNewRouter('order-record')"
        v-if="permissionCodes.indexOf('017001005') !== -1"
      >
        <i class="el-icon-damai-tongzhidan"></i>
        <span slot="title">预订记录</span>
      </el-menu-item>

      <el-menu-item
        index="6"
        @click="toNewRouter('agent-apply')"
        v-if="permissionCodes.indexOf('017001006') !== -1"
      >
        <i class="el-icon-damai-jijiangdaoqi"></i>
        <span slot="title">预约记录</span>
      </el-menu-item>

      <el-menu-item
        index="5"
        @click="toNewRouter('agent-showing')"
        v-if="permissionCodes.indexOf('017004000') !== -1"
      >
        <i class="el-icon-damai-fangyuan"></i>
        <span slot="title">看房记录</span>
      </el-menu-item>

      <el-menu-item
        index="4"
        @click="toNewRouter('agent-config')"
        v-if="permissionCodes.indexOf('017005000') !== -1"
      >
        <i class="el-icon-damai-shezhi"></i>
        <span slot="title">配置管理</span>
      </el-menu-item>

      <el-menu-item
        index="8"
        @click="toNewRouter('agent-log')"
        v-if="permissionCodes.indexOf('017007000') !== -1"
      >
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["custom-management", "custom-add", "custom-modify", "custom-current"],
  2: "agent-manage",
  3: ["agent-house", "agent-house-add"],
  4: "agent-config",
  5: ["agent-showing", "agent-showing-add", "agent-showing-modify"],
  6: "agent-apply",
  7: ["investment-manage", "investment-add"],
  9: "order-record",
  8: 'agent-log'
});

export default {
  name: "phone-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentNav.vue